var map = {
	"./default_avatar_0.png": 153,
	"./default_avatar_1.png": 154,
	"./default_avatar_10.png": 155,
	"./default_avatar_11.png": 156,
	"./default_avatar_12.png": 157,
	"./default_avatar_13.png": 158,
	"./default_avatar_14.png": 159,
	"./default_avatar_15.png": 160,
	"./default_avatar_16.png": 161,
	"./default_avatar_17.png": 162,
	"./default_avatar_2.png": 163,
	"./default_avatar_3.png": 164,
	"./default_avatar_4.png": 165,
	"./default_avatar_5.png": 166,
	"./default_avatar_6.png": 167,
	"./default_avatar_7.png": 168,
	"./default_avatar_8.png": 169,
	"./default_avatar_9.png": 170
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 152;